// Runtime configuration, served as /config.json next to the app. CDK writes it per
// environment, so the same build is promoted dev → qa → staging → prod (docs/architecture.md §3).

export interface AppConfig {
  environment: string;
  apiUrl: string;
  cognito: { region: string; userPoolId: string; webClientId: string };
}

export async function loadConfig(): Promise<AppConfig> {
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`config.json: HTTP ${res.status}`);
  return (await res.json()) as AppConfig;
}
